// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
  margin-top: 3rem;
  padding: 2.5rem 2rem;
  background-color: #f3f4f6;
  color: #4b5563;
}

@media (prefers-color-scheme: dark) {
  .site-footer {
    background-color: #0b1120;
    color: #9ca3af;
  }
}

.site-footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 0.9rem;
  display: flex;
  justify-content: center;
}

.site-footer-docs {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.site-footer-section {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.site-footer-section-title {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.85;
  color: inherit;
}

.site-footer-docs-list {
  list-style: none;
  margin: 0.25rem 0 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
}

.site-footer-docs-list li {
  white-space: nowrap;
}

.site-footer-docs-list a,
.site-footer-docs-list a:visited {
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color 0.15s, border-color 0.15s;
}

.site-footer-docs-list a:hover {
  color: #2563eb;
  border-color: rgba(37, 99, 235, 0.4);
}

.site-footer-info {
  margin-top: 0.75rem;
  font-size: 0.9rem;
  opacity: 0.85;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.site-footer-info-title {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  opacity: 0.9;
}

.site-footer-info-name {
  font-weight: 600;
}

.site-footer-info-inn {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 0.85rem;
}

`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+GAA+G;EAC/G,kBAAkB;AACpB","sourcesContent":[".site-footer {\n  margin-top: 3rem;\n  padding: 2.5rem 2rem;\n  background-color: #f3f4f6;\n  color: #4b5563;\n}\n\n@media (prefers-color-scheme: dark) {\n  .site-footer {\n    background-color: #0b1120;\n    color: #9ca3af;\n  }\n}\n\n.site-footer-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  font-size: 0.9rem;\n  display: flex;\n  justify-content: center;\n}\n\n.site-footer-docs {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.site-footer-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.site-footer-section-title {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  opacity: 0.85;\n  color: inherit;\n}\n\n.site-footer-docs-list {\n  list-style: none;\n  margin: 0.25rem 0 0 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.5rem;\n}\n\n.site-footer-docs-list li {\n  white-space: nowrap;\n}\n\n.site-footer-docs-list a,\n.site-footer-docs-list a:visited {\n  color: inherit;\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: color 0.15s, border-color 0.15s;\n}\n\n.site-footer-docs-list a:hover {\n  color: #2563eb;\n  border-color: rgba(37, 99, 235, 0.4);\n}\n\n.site-footer-info {\n  margin-top: 0.75rem;\n  font-size: 0.9rem;\n  opacity: 0.85;\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.site-footer-info-title {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.8rem;\n  opacity: 0.9;\n}\n\n.site-footer-info-name {\n  font-weight: 600;\n}\n\n.site-footer-info-inn {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n  font-size: 0.85rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
